export default __webpack_public_path__ + "static/media/ic_phone_white.cc883555.png";